import GridTable from "@/routes/org/_components/table/grid-table"
import Pagination from "@/components/pagination"
import { tableStore } from "@/routes/org/_components/table/table-store"
import LeakDetailModal from "@/routes/org/_components/modal/leak-detail-modal"
import FilterControls from "./filter/filter-controls"
import TableToolbar from "./table-toolbar"
import GridCards from "@/routes/org/_components/table/grid-cards"
import useResponsiveRowsPerPage from "@/routes/org/_components/table/use-responsive-rows-per-page"
import useIsMobile from "@/hooks/use-is-mobile"
import { useParams } from "react-router-dom"
import { useState, useEffect } from "react"
import { useRef } from "react"
import { useToggleStore } from "@/hooks/use-toggle-store"

const TableView = () => {
  useResponsiveRowsPerPage()
  const isMobile = useIsMobile()
  const { org } = useParams()
  const { show } = useToggleStore("filter")

  const { headers, rows, setPage, pageMeta } = tableStore()

  const [input, setInput] = useState("")
  const isFirstRender = useRef(true)

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false
      return
    }

    const timer = setTimeout(() => {
      tableStore.getState().setSearchTerm(org, input)
    }, 800)

    return () => clearTimeout(timer)
  }, [input, org])

  return (
    <section className={`relative ${show ? "z-100" : "z-5"} mt-8 md:mt-10`}>
      <FilterControls headers={headers} />

      <TableToolbar
        search={(e) => setInput(e.target.value)}
        resultCountText={pageMeta.totalCount.toLocaleString()}
      />

      {isMobile ? <GridCards rows={rows} /> : <GridTable headers={headers} rows={rows} />}

      {pageMeta.totalPage > 1 && (
        <Pagination
          currentPage={pageMeta.page}
          totalPages={pageMeta.totalPage}
          onChange={(page) => setPage(org, page)}
        />
      )}

      <LeakDetailModal />
    </section>
  )
}

export default TableView
